module.exports = __webpack_public_path__ + "static/media/email-login.94e18cfd.svg";